// extracted by mini-css-extract-plugin
export default {"menuGroupItems":"MenuGroup_menuGroupItems__CZFNd","menuGroupHeader":"MenuGroup_menuGroupHeader__+RTZ3"};